/* SHOP BY CATEGORY */
export const shopByCategory = [
  {
    id: 1,
    category: "Cigar",
  },
  {
    id: 2,
    category: "C-Store",
  },
  {
    id: 3,
    category: "Flower / Wax / Oil",
  },
  {
    id: 4,
    category: "Glass",
  },
  {
    id: 5,
    category: "Hookah",
  },
  {
    id: 6,
    category: "Roll your own",
  },
];

/* SHOP BY BRAND */
export const shopByBrand = [
  {
    id: 1,
    brand: "Dr. Dabber",
  },
  {
    id: 2,
    brand: "Focus V",
  },
  {
    id: 3,
    brand: "Huni Badger",
  },
  {
    id: 4,
    brand: "Lookah",
  },
  {
    id: 5,
    brand: "Newport Zero",
  },
];

/* SHOP BY NAME */
export const shopByName = [
  {
    id: 1,
    name: "11 in 1 Water Pipe Kit Gift Set",
  },
  {
    id: 2,
    name: "Butt Bucket Next Ashtray W/O Lid 12CT",
  },
  {
    id: 3,
    name: "Collector Edition Round Glass",
  },
  {
    id: 4,
    name: "Jamaican Resin Ashtray | Large",
  },
];
